module.exports = __webpack_public_path__ + "img/070-099.f0b09c6d.png";